import classNames from 'classnames'
import React, { useContext, useEffect, useState } from 'react'
import iconSelectInput from '../../assets/iconSelectInput.svg'

import closeModalIcon from '../../assets/closeModal.svg'
import { useFormik } from 'formik'
import UserContext from 'contexts/UserContext'
import { LISTBANCAIRE } from 'components/listCartebancairepays'

import { Pakistan,Senegal, Maroc, Bangladech,Tunisie, Turquie, kenya, Nigeria, Philippines} from 'assets/drapeauxCarres/index'
import transferBeneficiaryContext from 'contexts/transferBeneficiaryContext'
import BeneficiaryInfo from './BeneficiaryInfo'
import BeneficiaryPersonalInfo from './BeneficiaryPersonalInfo'
import { AddBeneficiary } from 'helpers/api'
import { createBeneficiaryValidationSchema } from './createBeneficiaryValidationSchema'
import Avatar from 'components/avatar'
interface Props {
  setIsOpen: (val: boolean) => void
  setIsBeneficiaryAdded: (val: boolean)=>void
}

interface FormValues {
  avatar: number
  firstName: string
  lastName: string
  gender: string
  relationship: string
  phonePrefix: string
  phoneNumber: string
  Iban: string
  confirmerNumeroCompte: string
  beneficiaryIdentifiant: string
  bankName: string
  CodeIBAN: string
  SWIFTBIC: string
  bankCode: string
}
type Bank = {
  index: number
  code: string
  name: string
  swift: string
}

type CountryConfig = {
  LengthRIB?: number | { min: number; max: number }
  LengthCIN?: number
  lengthPhone: number
  lengthCodeIBAN?: number
  CodeIBAN?: string
  banks?: Bank[]
}

const ModalAddBeneficiary: React.FC<Props> = ({ setIsOpen, setIsBeneficiaryAdded }) => {
  const optionsPrefix = [
    { icon: Tunisie, value: '+216', label: '216', lengthPhone: 8, code: 'TUN' },
    { icon: Maroc, value: '+212', label: '212', lengthPhone: 9, code: 'MAR' },
    { icon: Senegal, value: '+221', label: '221', lengthPhone: 9, code: 'SEN' },
    { icon: Turquie, value: '+90', label: '90', lengthPhone: 10, code: 'TUR' },
    { icon: Pakistan, value: '+92', label: '92', lengthPhone: 10, code: 'PAK' },
    { icon: Bangladech, value: '+880', label: '880', lengthPhone: 10, code: 'BGD' },
    { icon: kenya, value: '+254', label: '254', lengthPhone: 9, code: 'KEN' },
    { icon: Nigeria, value: '+234', label: '234', lengthPhone: 10, code: 'NGA' },
    { icon: Philippines, value: '+63', label: '63', lengthPhone: 10, code: 'PHL' },
  ]

  const [avatar, setAvatar] = useState(25)
  const [isSelf, setIsSelf] = useState(false)
  const { user } = useContext(UserContext)
  const { TransferData, setTransferData } = useContext(transferBeneficiaryContext)
  const [detailsPays, setDetailsPays] = useState<CountryConfig>()
  const [openOptionnel, setOpenOptionnel] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const destinationDefaultCountry = user?.user.destinationDefaultCountry=== 'MAC' ? 'MAR' : user?.user.destinationDefaultCountry
  const id= user?.user._id
  const Token = user?.token?.accessToken
  const optionprefixSlected = TransferData?.codeIso
    ? optionsPrefix.find((item) => item.code === TransferData.codeIso)
    : optionsPrefix.find((item) => item.code === destinationDefaultCountry)

    

  const getSelectedPrefix = (phonePrefix: string) => {
    const filter = optionsPrefix.find((item) => item.label === phonePrefix)
    if (filter) return LISTBANCAIRE[filter.code]
  }



  const initialValues: FormValues = {
    avatar: avatar,
    firstName: '',
    lastName: '',
    gender: '',
    relationship: '',
    phonePrefix: optionprefixSlected?.label ?? '216',
    phoneNumber: '',
    Iban: '',
    confirmerNumeroCompte: '',
    beneficiaryIdentifiant: '',
    bankName: '',
    CodeIBAN: '',
    SWIFTBIC: '',
    bankCode: '',
  }
  
  const handleSubmit = async (values: FormValues) => {
    setIsLoading(true)
    
  try{
    const response = await AddBeneficiary(id, Token, values)
    if(response.success)
    {
      setIsBeneficiaryAdded(true)
      if(TransferData){
        setTransferData({
                  ...TransferData,
                  BeneficiaryName: `${response?.data?.personalInfo?.firstName} ${response?.data?.personalInfo?.lastName} `,
                  idBeneficiary: response?.data?._id,
                  cinBeneficiary: response?.data?.identifiantCardNumber,
                  numBankBeneficiary: response?.data?.accountNumber,
                  banqueName: response.data.bankName,
                  bankcode: response.data.bankCode,
                  swiftBic: response.data.SWIFTBIC,
                  phoneNumberBeneficiary: `${response?.data?.personalInfo.phone.prefix} ${response?.data?.personalInfo.phone.number} `,
                })
      }
      setIsOpen(false)
    }
   
  }catch(error){console.log(error)}
  finally {
    setIsLoading(false)
  }

}

  const formik = useFormik<FormValues>({
    initialValues,
    validateOnMount: true,
    validationSchema: createBeneficiaryValidationSchema(),
    onSubmit: handleSubmit,
  })
const isTurkeyOrPhilippines =
  formik.values.phonePrefix === '90' || formik.values.phonePrefix === '63'

  useEffect(() => {
      if(isTurkeyOrPhilippines) {return}

      if(!formik.values.Iban ) {

        formik.setFieldValue('bankName', '')
        formik.setFieldValue('SWIFTBIC', '')
        formik.setFieldValue('bankCode', '')
        return
      }

          const PaysSelected= getSelectedPrefix(formik.values.phonePrefix)
          const bankCodeAccount = formik.values.Iban.substring(0, PaysSelected?.lengthCodeIBAN)
          const bank = PaysSelected?.banks?.find((item) => item.code === bankCodeAccount)
          if (bank!== undefined) {
            formik.setFieldValue('bankName', bank.name, false)
            formik.setFieldValue('SWIFTBIC', bank.swift, false)
            formik.setFieldValue('bankCode', bank.code, false)
          }   
  }, [formik.values.Iban, formik.values.phonePrefix])

 
  useEffect(() => {
    const value = optionsPrefix.find((item) => item.label === formik.values.phonePrefix)
    const Liste = LISTBANCAIRE[value?.code || 'TUN']
    setDetailsPays(Liste)
       if(isTurkeyOrPhilippines ) 
       formik.setFieldValue('bankName','', false)
      if(Liste.CodeIBAN)
      {
        formik.setFieldValue('CodeIBAN',Liste.CodeIBAN)
        
      }else{formik.setFieldValue('CodeIBAN','')}

  }, [formik.values.phonePrefix])

  useEffect(() => {
    if (formik.values.relationship === 'SELF') {
      formik.setValues(
        {
          ...formik.values,
          firstName: user?.user.personalInfo.firstName ?? '',
          lastName: user?.user.personalInfo.lastName ?? '',
          gender: user?.user.personalInfo.gender ?? '',
        },
        true,
      )
      setIsSelf(true)
    } else {
      setIsSelf(false)
    }
  }, [formik.values.relationship])
  
  useEffect(()=>{
     formik.setFieldValue('avatar', avatar)
  },[avatar])


 return (
    <div
      className='items-center flex fixed  z-20  inset-0  shadow-inner bg-[rgba(87,84,229,0.6)] backdrop-blur-[5px] w-full'>
      <div className={classNames(' shadow-[0px_4px_10px, rgba(0,0,0,0.25)] p-[25px] sm:p-4 rounded-2xl flex flex-col  mx-auto bg-white ')}>
        <img
          src={closeModalIcon}
          width={20}
          height={20}
          onClick={() => setIsOpen(false)}
          className=" self-end   justify-end hover:cursor-pointer xs:w-[18px] sm:mx-2 sm:mt-3"
        />
        <div className="flex flex-col items-center">
          <Avatar ifUpdate={true} avatar={avatar} setAvatar={setAvatar} />
        </div>
        <form onSubmit={formik.handleSubmit}>
         
         <div className='max-h-[500px] my-6 flex flex-col gap-4 overflow-y-auto scrollbar-webkit  px-2'>
          <BeneficiaryInfo formik={formik} isSelf={isSelf} 
            optionsPrefix={optionprefixSlected && TransferData?.codeIso ? [optionprefixSlected] : optionsPrefix} />

          {detailsPays?.banks && detailsPays.banks.length > 0 && (
            <div>
              <h2
                className="h3 flex hover:cursor-pointer items-center justify-between  w-[50%]"
                onClick={() => setOpenOptionnel(!openOptionnel)}
              >
                Informations optionnelles
                <img src={iconSelectInput} className={` ${openOptionnel && ' rotate-180'}`} width={12} height={12} />
              </h2>
              {openOptionnel && (
                <BeneficiaryPersonalInfo
                  formik={formik}
                  prefixSelected={formik.values.phonePrefix}
                  detailsPays={detailsPays}
                />
              )}
            </div>
          )}
        </div>
          <button
            disabled={!formik.isValid}
            className='buttonBlue w-full mb-2'
            type="submit"
          >
            {isLoading ? (
            <svg
              className="w-6 h-6 mx-auto animate-spin text-white "
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle className="opacity-50" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8V0C6.477 0 2 4.477 2 10h2zm2 5.291A7.971 7.971 0 014 12H2c0 2.21.896 4.209 2.344 5.656l1.656-1.365z"
              ></path>
            </svg>
          ) : (
            'Ajouter'
          )}
          </button>
       
        </form>
      </div>
    </div>
  )
}

export default ModalAddBeneficiary